import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util,$cookie} from "@util/util.js";

export default class ArrivalGoodsWapView extends BaseView {
    constructor(model) {
        super(model);
        this._model._view = this;

        // this._parentEl = this._model._parent._view._arrivalgoodsBoxEl;
        this._el = null;
        // 全局定时器
        this.timer = null;
    }

    render() {

        let firstChildDomain = document.domain.indexOf(".");
        let _domain = document.domain.substr(firstChildDomain+1);
        this._el = $(".subscribe_mask");
        
        $('.captcha_validate').attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
        // 清空错误提示
        $('.subscribe_inputc input').val('');
        $('.captcha_validate').siblings('input').val('');
        $('.captcha_btn').siblings('input').val('');

        this.regEvent();
    }
    regEvent() {
        let that = this;
        let vcount = 0;
        let firstChildDomain = document.domain.indexOf(".");
        let _domain = document.domain.substr(firstChildDomain+1);

        this._el.off("click", ".btn_group .cancel']").on("click", ".btn_group .cancel", function () {
            // 点击隐藏到货通知弹框
            // 每次打开到货通知页面 , 就渲染一次验证码
            clearInterval(that.timer);
            $('.subscribe_mask').hide();
            $('.subscribe_inputc input').val('');
            $('.captcha_validate').siblings('input').val('');
            $('.captcha_btn').siblings('input').val('');
            $(".captcha_btn").css('pointer-events', 'unset');
            $(".captcha_btn").html("获取验证码");
            $util.toggleBodyScroller(false);
        })
        // 更换验证码
        this._el.off("click", ".captcha_validate']").on("click", ".captcha_validate", function () {
            $(this).attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
        })
        // 点击修改清空输入框
        this._el.off("click", ".subscribe_inputc span']").on("click", ".subscribe_inputc span", function () {
            $('.subscribe_inputc input').val('');
        })
        this._el.off("click", ".captcha_btn']").on("click", ".captcha_btn", function () {
            // 判断是点击重新发送还是获取验证码
            if($(this).html() == '重新发送') {
                vcount++;
                if(vcount == 1) {
                    // 每次点机获取验证码就更换图形验证
                    $('.captcha_validate').siblings('input').val('');
                    $(".subscribe_mask .captcha_validate").attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
                }
                
            } 
            if ($('.subscribe_inputc input').val() == '') {
                Alert.showTip("手机号不能为空");
                return false;
            } else {
                var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!reg.test($('.subscribe_inputc input').val())) {
                    Alert.showTip("手机号格式不正确");
                    return false;
                } else {
                    if($('.captcha_validate').siblings('input').val() == '') {
                        Alert.showTip("图形验证不能为空");
                        return false;
                    } else {
                        
                        var phone = $('.subscribe_inputc input').val();
                        // 获取cookie的leid
                        var leID = '';
                        var leIDArr = document.cookie.split('; ');
                        for (var i = 0; i < leIDArr.length; i++) {
                            if (leIDArr[i].split('=')[0] == 'leid') {
                                leID = leIDArr[i].split('=')[1];
                            }
                        }
                       
                        var aurl = 'https://papi.'+_domain;
                        
                        $.ajax({
                            url: aurl + '/stock/sendsms.jhtm',
                            type: "GET",
                            data: {
                                "mobile": phone,
                                "leId": leID,
                                "vcode": $('.captcha_validate').siblings('input').val()
                            },
                            dataType: "jsonp",
                            jsonp: "jsonpcallback",
                            jsonpCallback: 'jQueryJSONP_stock_sendsms',
                            timeout: 5000,
                            success: function (data) {
                                if (data && (data.success || data.resultCode == "0000")) {
                                    
                                    // alert('验证码已发送至您的手机，请注意查收!');
                                    var countTime = 120;
                                    $(".captcha_btn").css('pointer-events', 'none');
                                    that.timer = setInterval(function () {
                                        countTime--;
                                        $(".captcha_btn").html("已发送" + countTime);

                                        if (countTime == 0) {
                                            clearInterval(that.timer);
                                            $(".captcha_btn").css('pointer-events', 'unset');
                                            $(".captcha_btn").html("重新发送");
                                        }
                                    }, 1000);
                                } else {
                                    Alert.showTip(data.resultMsg);
                                    // 每次点机获取验证码就更换图形验证
                                    $('.captcha_validate').siblings('input').val('');
                                    $(".subscribe_mask .captcha_validate").attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
                                }
                            }
                        })
                    }
                }
            }
        })
        // 点击确定, 调到货通知的接口
        this._el.off("click", ".btn_group .confirm']").on("click", ".btn_group .confirm", function () {
            // 校验非空和格式
            if ($('.subscribe_inputc input').val() == '') {
                Alert.showTip("手机号不能为空");
                return false;
            } else {
                var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!reg.test($('.subscribe_inputc input').val())) {
                    Alert.showTip("手机号码格式不正确");
                    return false;
                } else {
                    if($('.captcha_validate').siblings('input').val() == '') {
                        Alert.showTip("图形验证不能为空");
                        return false;
                    } else if($('.captcha_btn').siblings('input').val() == '') {
                        Alert.showTip("短信验证码不能为空");
                        return false;
                    } else {
                        $('.error-container').hide();
                        var phone = $('.subscribe_inputc input').val();
                        var leID = $cookie.getCookie('leid');
                        // let lenovoId = passport.cookie.lenovoId;
                        // let memberCode = passport.cookie.loginName;
                        if (that._model._parent._data._subscribe) {
                            var activetyType = 5;
                        } else if (that._model._parent._data._subscribeSnap) {
                            var activetyType = 3;
                        } else if (that._model._parent._data._kill) {
                            var activetyType = 2;
                        } else {
                            // 普通商品
                            var activetyType = 0;
                        }
                       
                        var aurl = 'https://papi.'+_domain;
                           
                        $.ajax({
                            type: 'GET',
                            url: aurl + '/stock/subscribe.jhtm',
                            data: {
                                activityType: activetyType, // 详情页活动类型：秒杀 2，预约抢购 3，秒杀倒计时 4， 预约 5
                                clientType: 'WAP',
                                linkAddress: that._model._arrivalGoods[0].linkAddress,
                                phone: phone,
                                productCode: that._model._arrivalGoods[0].code,
                                productName: that._model._arrivalGoods[0].name,
                                smsCode: $('.captcha_btn').siblings('input').val(),
                                lenovoAccount: passport.cookie.loginName,    //'15575925447'
                                lenovoID: passport.cookie.lenovoId,        //10127832429
                                mallName: '联想官网',
                                leID: leID
                            },
                            dataType: "jsonp",
                            jsonp: "jsonpcallback",
                            jsonpCallback: 'jQueryJSONP_stock_subscribe',
                            timeout: 5000,
                            success: function (res) {
                                if(res.resultCode == '0000') {
                                    Alert.showTip("订阅成功");
                                    $('.subscribe_mask').hide();
                                    $('.subscribe_inputc input').val('');
                                    $('.captcha_validate').siblings('input').val('');
                                    $('.captcha_btn').siblings('input').val('');
                                    clearInterval(that.timer);
                                    $(".captcha_btn").css('pointer-events', 'unset');
                                    $(".captcha_btn").html("获取验证码");
                                    $util.toggleBodyScroller(false);
                                } else if(res.resultCode == '20203') {
                                    Alert.showTip(res.resultMsg);
                                } else {
                                    Alert.showTip(res.resultMsg);
                                }
                            }
                        })
                    }
                }
            }
        })
    }
}